module.exports = __webpack_public_path__ + "img/image_10.1946934d.png";